export default __webpack_public_path__ + "img/img/add-profile.458863c6.svg";